module.exports = __webpack_public_path__ + "static/media/20110524_4520.c9f67dec.jpg";